import * as yup from 'yup';
export const UserEmulationSchema = yup.object().shape({
    email: yup
        .string()
        .email('Invalid email')
        .required('Value is required')
        .min(1, 'Value is required'),
});
